import {
  Key,
  Language,
  Logout,
  Monitor,
  PhoneAndroid,
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
} from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { useLoggedInEmployeeProfile } from '~/components/Auth';
import { ChangeLanguage } from '~/legacy-components/ChangeLanguage';
import { LegacyChangePassword } from '~/legacy-components/LegacyChangePassword';
import { useSxStyles } from '~/scenes/MobileViews/components/MobileMainMenuContent/useStyles';

export const MobileMainMenuContent = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const employeeProfile = useLoggedInEmployeeProfile();
  const employeeFullName = `${employeeProfile.firstName} ${employeeProfile.lastName}`;

  const [openDialogName, setOpenDialogName] = useState('');
  const dialogOpenChange = (name: string) => {
    setOpenDialogName(name);
  };
  const resetDialog = () => {
    setOpenDialogName('');
  };

  const renderOpenDialog = (dialogName: string) => {
    switch (dialogName) {
      case 'changePassword':
        return <LegacyChangePassword resetDialog={resetDialog} />;
      case 'changeLanguage':
        return <ChangeLanguage resetDialog={resetDialog} />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <Box sx={sxStyles.userProfile}>
        <Avatar
          variant="circular"
          alt={employeeFullName}
          src={employeeProfile.profilePic}
        />
        <Typography variant={'h6'}>{employeeFullName}</Typography>
      </Box>
      <MenuList>
        <MenuItem onClick={() => dialogOpenChange('changePassword')}>
          <ListItemIcon>
            <Key />
          </ListItemIcon>
          <ListItemText>{t('laPassword')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => dialogOpenChange('changeLanguage')}>
          <ListItemIcon>
            <Language />
          </ListItemIcon>
          <ListItemText>{t('laLanguage')}</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem component={Link} href={'/mobile.html'}>
          <ListItemIcon>
            <PhoneAndroid />
          </ListItemIcon>
          <ListItemText>{t('oldMobileMode')}</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem component={RouterLink} to={'/portal/continue'}>
          <ListItemIcon>
            <Monitor />
          </ListItemIcon>
          <ListItemText>{t('desktopMode')}</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem component={Link} href={'/page-logout'}>
          <ListItemIcon>
            <Logout />
          </ListItemIcon>
          <ListItemText>{t('logout')}</ListItemText>
        </MenuItem>
      </MenuList>
      {renderOpenDialog(openDialogName)}
    </>
  );
};
